import type { BuyerDataSource } from '~/api/data-source/buyer';
import { buyerDataSource } from '~/api/data-source/buyer';
import type { Buyer, BuyerMyPage, BuyerPlusMembership } from '~/api/model';
import {
  buyerMyPageSchema,
  buyerPlusMembershipSchema,
  buyerSchema,
  safeParseModel,
} from '~/api/model';

export interface BuyerRepository {
  // Query
  getBuyer(): Promise<Buyer | null>;
  getBuyerPlusMembership(): Promise<BuyerPlusMembership | null>;
  getBuyerMyPage(): Promise<BuyerMyPage | null>;
}

export class BuyerRepositoryImpl implements BuyerRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly dataSource: BuyerDataSource = buyerDataSource) {}

  async getBuyer() {
    const response = await this.dataSource.getBuyer();
    return safeParseModel(buyerSchema, response);
  }

  async getBuyerPlusMembership() {
    const response = await this.dataSource.getBuyerPlusMembership();
    return safeParseModel(buyerPlusMembershipSchema, response);
  }

  async getBuyerMyPage() {
    const response = await this.dataSource.getBuyerMyPage();
    return safeParseModel(buyerMyPageSchema, response);
  }
}

export const buyerRepository = new BuyerRepositoryImpl();
